import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AddressEffects } from './address/address.effects';
import { AnnualRewardEffects } from './annual-reward/annual-reward.effects';
import { CalculationEffects } from './calculation/calculation.effects';
import { CountryEffects } from './country/country.effects';
import { InvoicesEffects } from './invoices/invoices.effects';
import { reducers } from './my-zone';
import { ProductEffects } from './product/product.effects';
import { ScenariosEffects } from './scenarios/scenarios.effects';

@NgModule({
    imports: [
        StoreModule.forFeature('myZone', reducers),
        EffectsModule.forFeature([
            ProductEffects,
            InvoicesEffects,
            CalculationEffects,
            ScenariosEffects,
            AddressEffects,
            CountryEffects,
            AnnualRewardEffects,
        ]),
    ],
})
export class MyZoneStoreModule {}
